import { createContext } from "react";

export interface IFiltersDropdownContext {
  hovered?: boolean;
  optionClicked?: boolean;
  showDropdown?: boolean;
  showDropdownOnClickOutside?: boolean;
  clickedSelectorContent?: any;
  handleOptionSelect?: () => void;
}

export const FiltersDropdownContext = createContext<IFiltersDropdownContext>({
  hovered: false,
  optionClicked: false,
  showDropdown: false,
  showDropdownOnClickOutside: false,
  clickedSelectorContent: {},
  handleOptionSelect: null,
});
